import { SET_USERS } from "../actions/types";

const INITIAL_STATE = {
  items: [],
  meta: {
    currentPage: 0,
    itemCount: 0,
    itemsPerPage: 0,
    totalItems: 0,
    totalPages: 0,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_USERS:
      return { ...state, items: action.payload };
    default:
      return { ...state };
  }
};
